import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  pending: false,
  list: [],
  item: {},
  cmd: []
});

export function setList(state, list) {
  const item = state.getIn(['dashboard', 'item'], {});
  list.forEach(tmp => {
    item[tmp.dashboardId] = tmp;
  });
  return state.merge({ list, item });
}

export function addCmd(state, data) {
  return state.update('cmd', cmd => cmd.push(data));
}

export function handleDashboardCmd(state, cmdId) {
  return state.update('cmd', cmd => cmd.delete(cmdId));
}

export function setPendingSelf(state, pending = true) {
  return state.set('pending', !!pending);
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'DASHBOARD_PENDING':
      return setPendingSelf(state, action.pending);

    case 'DASHBOARD_LIST':
      return setList(state, action.list);

    case 'DASHBOARD_CMD':
      return addCmd(state, action.data);
    case 'DASHBOARD_HANDLE_CMD':
      return handleDashboardCmd(state, action.cmdId);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/dashboards.js